export default __webpack_public_path__ + "static/media/16.e7f4cd70.jpg";